/* DIBAMEX — Tiempo de entrega estimado v3.3
 * Cambios frente a la 3.2 — CALIBRACION MEDIDA, ya no son estimaciones:
 *  f. CFG.zonas sale de 513 envios entregados, medidos en dias habiles desde el
 *     dia de surtido con el mismo corte de las 12:00 que usa este archivo.
 *     Se elimina Z4: ahora son Z1 Baja California, Z2 Noroeste y Z3 resto del pais.
 *  g. Ya no se oculta el aereo por el peso de la variante. El peso de una pieza
 *     no predice el del envio: quien ve un articulo puede agregar quince.
 *  h. El texto dice "normalmente llega", no "llega". Los rangos cumplen entre
 *     69% y 100% segun la zona; son promesas ajustadas, no garantias.
 *  i. Linea de contacto visible por si se pasa la fecha.
 *  j. Un estado que no este en CFG.estadoZona cae a Z3 en vez de quedarse sin
 *     zona. Elimina la clase de error del prefijo 99.
 *
 * Cambios frente a la 3.1:
 *  d. CP2EDO no cubria el prefijo 99 (Zacatecas). Mil codigos postales no
 *     resolvian estado, asi que el cliente no podia capturar su CP. Corregido.
 *  e. Un CP de 5 digitos que no resuelva zona ya no se descarta en silencio:
 *     se acepta, se muestra el plazo nacional y se avisa que no se reconocio.
 *
 * Cambios frente a la 3.0:
 *  a. Zona local (Mexicali): mismo dia, maximo 1 dia habil, con flotilla propia.
 *     Ya no se muestra como si fuera paqueteria.
 *  b. Aereo alineado a la condicion comercial: 2 a 3 dias habiles nacionales,
 *     rotulado como costo adicional, y solo se muestra si es mas rapido que el terrestre.
 *  c. Recoleccion en mostrador sin costo.
 *
 * Cambios frente a la 2.7.1:
 *  1. El corte SI mueve la fecha. Antes el contador era decorativo.
 *  2. Zonas por codigo postal. Antes Tijuana y Merida veian lo mismo.
 *  3. Salta dias festivos, no solo fines de semana.
 *  4. Oculta el aereo cuando la variante pasa el limite de peso.
 *  5. Sin polling de 250 ms. Eventos + observer acotado al formulario.
 *  6. Colores de marca y contraste AA.
 *
 *  ORIGEN: Mexicali, Baja California.
 */
(function () {
  'use strict';
  if (window.DBXDeliveryLoaded) return;
  window.DBXDeliveryLoaded = true;

  /* ==========================================================================
   * CONFIG — lo unico que hay que tocar para ajustar tiempos.
   * Los dias son DIAS HABILES de transito, ya sin contar el dia de surtido.
   * VALIDAR con Estafeta antes de publicar. Ver nota al final del archivo.
   * ========================================================================== */
  var CFG = {
    tz: 'America/Tijuana',
    cutoff: '12:00',            // hora local de Mexicali
    umbralEnvioGratisMXN: 999,

    // ---- Zona local: reparto con flotilla propia, no paqueteria ----
    // Rangos de CP que se entregan con camioneta de DIBAMEX.
    // 21000-21399 es la mancha urbana de la ciudad de Mexicali. Queda fuera a
    // proposito el resto del municipio (valle, San Felipe, Los Algodones,
    // Cd. Morelos, Guadalupe Victoria), que sale por paqueteria como Z1.
    // Para ampliar o recortar la cobertura, solo se toca esta linea.
    zonaLocalCP: [[21000, 21399]],
    zonaLocalNombre: 'Mexicali',
    zonaLocalHabiles: [0, 1],   // 0 = el mismo dia de surtido, 1 = a mas tardar el siguiente habil

    // ---- Recoleccion en mostrador, sin costo ----
    mostrarRecoleccion: 'siempre',   // 'siempre' | 'local' | 'nunca'
    mostrador: 'Republica de Ecuador 999-C, Col. Compuertas, Mexicali',

    // Zonas desde Mexicali. terrestre:[min,max], aereo:[min,max] en dias habiles.
    // MEDIDO sobre 513 envios entregados, no estimado. El aereo es siempre
    // 2 a 3 dias habiles CON COSTO ADICIONAL. Cumplimiento real de cada
    // rango, al pie del archivo.
    zonas: {
      Z1: { nombre: 'Baja California', terrestre: [2, 3], aereo: [2, 3] },
      Z2: { nombre: 'Noroeste',        terrestre: [3, 5], aereo: [2, 3] },
      Z3: { nombre: 'Resto del pais',  terrestre: [4, 6], aereo: [2, 3] }
    },

    // Estado -> zona. Solo se listan las excepciones: cualquier estado que no
    // aparezca aqui cae a zonaPorDefecto. Asi un estado olvidado en la tabla
    // no se queda sin plazo, que fue lo que paso con el prefijo 99.
    estadoZona: {
      BC: 'Z1',
      BCS: 'Z2', SON: 'Z2', SIN: 'Z2'
    },
    zonaPorDefecto: 'Z3',

    // Rango generico mientras el cliente no da su CP.
    generico: { terrestre: [4, 6], aereo: [2, 3] },

    // Cierres de la paqueteria ademas de sabado y domingo.
    // Fijos del articulo 74 de la LFT. Semana Santa se calcula aparte.
    cerrarSemanaSanta: true,     // jueves y viernes santo — confirmar con Estafeta
    festivosExtra: []            // 'YYYY-MM-DD' para cierres puntuales
  };

  /* ==========================================================================
   * Codigos postales de Mexico: los dos primeros digitos identifican el estado.
   * Validado contra 96 pedidos reales de DIBAMEX: 97.9% de acierto.
   * ========================================================================== */
  var CP2EDO = (function () {
    var m = {};
    function set(desde, hasta, edo) {
      for (var i = desde; i <= hasta; i++) m[('0' + i).slice(-2)] = edo;
    }
    set(1, 16, 'DF');    set(20, 20, 'AGS');  set(21, 22, 'BC');   set(23, 23, 'BCS');
    set(24, 24, 'CAMP'); set(25, 27, 'COAH'); set(28, 28, 'COL');  set(29, 30, 'CHIS');
    set(31, 33, 'CHIH'); set(34, 35, 'DGO');  set(36, 38, 'GTO');  set(39, 41, 'GRO');
    set(42, 43, 'HGO');  set(44, 49, 'JAL');  set(50, 57, 'MEX');  set(58, 61, 'MICH');
    set(62, 62, 'MOR');  set(63, 63, 'NAY');  set(64, 67, 'NL');   set(68, 71, 'OAX');
    set(72, 75, 'PUE');  set(76, 76, 'QRO');  set(77, 77, 'QROO'); set(78, 79, 'SLP');
    set(80, 82, 'SIN');  set(83, 85, 'SON');  set(86, 86, 'TAB');  set(87, 89, 'TAMPS');
    set(90, 90, 'TLAX'); set(91, 96, 'VER');  set(97, 97, 'YUC');  set(98, 99, 'ZAC');
    return m;
  })();

  var EDO_NOMBRE = {
    AGS:'Aguascalientes', BC:'Baja California', BCS:'Baja California Sur', CAMP:'Campeche',
    CHIS:'Chiapas', CHIH:'Chihuahua', COAH:'Coahuila', COL:'Colima', DF:'Ciudad de Mexico',
    DGO:'Durango', GTO:'Guanajuato', GRO:'Guerrero', HGO:'Hidalgo', JAL:'Jalisco',
    MEX:'Estado de Mexico', MICH:'Michoacan', MOR:'Morelos', NAY:'Nayarit', NL:'Nuevo Leon',
    OAX:'Oaxaca', PUE:'Puebla', QRO:'Queretaro', QROO:'Quintana Roo', SLP:'San Luis Potosi',
    SIN:'Sinaloa', SON:'Sonora', TAB:'Tabasco', TAMPS:'Tamaulipas', TLAX:'Tlaxcala',
    VER:'Veracruz', YUC:'Yucatan', ZAC:'Zacatecas'
  };

  var COLOR = { navy: '#0A3254', lima: '#D2EF0E', gris: '#4F4F4F' };
  var ID = 'delivery-time-container';
  var LS_CP = 'dbx_cp_destino';

  /* ============================ Fechas ============================ */

  function ahoraEnTZ(tz) {
    var f = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var p = {};
    f.forEach(function (x) { p[x.type] = x.value; });
    return {
      y: +p.year, m: +p.month, d: +p.day,
      hh: +p.hour % 24, mm: +p.minute,
      fecha: new Date(Date.UTC(+p.year, +p.month - 1, +p.day))
    };
  }

  // Domingo de Pascua (Meeus/Jones/Butcher). Deterministico, no es un dato inventado.
  function pascua(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31);
    var dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, mes - 1, dia));
  }

  function nLunes(y, mes, n) {           // n-esimo lunes del mes (mes 1-12)
    var d = new Date(Date.UTC(y, mes - 1, 1));
    while (d.getUTCDay() !== 1) d.setUTCDate(d.getUTCDate() + 1);
    d.setUTCDate(d.getUTCDate() + 7 * (n - 1));
    return d;
  }

  var _festCache = {};
  function festivos(y) {
    if (_festCache[y]) return _festCache[y];
    var s = {};
    function add(dt) { s[dt.toISOString().slice(0, 10)] = true; }
    add(new Date(Date.UTC(y, 0, 1)));    // 1 enero
    add(nLunes(y, 2, 1));                // primer lunes de febrero
    add(nLunes(y, 3, 3));                // tercer lunes de marzo
    add(new Date(Date.UTC(y, 4, 1)));    // 1 mayo
    add(new Date(Date.UTC(y, 8, 16)));   // 16 septiembre
    add(nLunes(y, 11, 3));               // tercer lunes de noviembre
    add(new Date(Date.UTC(y, 11, 25)));  // 25 diciembre
    if (y % 6 === 0) add(new Date(Date.UTC(y, 11, 1))); // transmision del Ejecutivo
    if (CFG.cerrarSemanaSanta) {
      var p = pascua(y);
      var ju = new Date(p); ju.setUTCDate(ju.getUTCDate() - 3);
      var vi = new Date(p); vi.setUTCDate(vi.getUTCDate() - 2);
      add(ju); add(vi);
    }
    CFG.festivosExtra.forEach(function (k) { if (k.slice(0, 4) === String(y)) s[k] = true; });
    _festCache[y] = s;
    return s;
  }

  function esHabil(d) {
    var w = d.getUTCDay();
    if (w === 0 || w === 6) return false;
    return !festivos(d.getUTCFullYear())[d.toISOString().slice(0, 10)];
  }

  function sumaHabiles(d, n) {
    var c = new Date(d.getTime()), i = 0;
    while (i < n) { c.setUTCDate(c.getUTCDate() + 1); if (esHabil(c)) i++; }
    return c;
  }

  function siguienteHabil(d) {
    var c = new Date(d.getTime());
    do { c.setUTCDate(c.getUTCDate() + 1); } while (!esHabil(c));
    return c;
  }

  var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio',
               'agosto','septiembre','octubre','noviembre','diciembre'];
  function fmt(d) { return d.getUTCDate() + ' de ' + MESES[d.getUTCMonth()]; }
  function iso(d) { return d.toISOString().slice(0, 10); }

  /* ================= Corte: aqui es donde SI cambia la fecha ================= */
  // Dia en que sale el paquete del almacen:
  //   hoy es habil y aun no da el corte -> sale hoy
  //   en cualquier otro caso           -> siguiente dia habil
  function diaDeSurtido(t) {
    var partes = CFG.cutoff.split(':');
    var corteMin = (+partes[0]) * 60 + (+partes[1] || 0);
    var ahoraMin = t.hh * 60 + t.mm;
    if (esHabil(t.fecha) && ahoraMin < corteMin) return new Date(t.fecha.getTime());
    return siguienteHabil(t.fecha);
  }

  function minutosAlCorte(t) {
    var partes = CFG.cutoff.split(':');
    var corteMin = (+partes[0]) * 60 + (+partes[1] || 0);
    var ahoraMin = t.hh * 60 + t.mm;
    if (esHabil(t.fecha) && ahoraMin < corteMin) return corteMin - ahoraMin;
    return null; // ya paso el corte de hoy
  }

  function corteBonito() {
    var p = CFG.cutoff.split(':');
    var h = +p[0], m = p[1] || '00';
    var ampm = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + m + ' ' + ampm;
  }

  /* ============================ Destino ============================ */

  function cpGuardado() {
    try { return localStorage.getItem(LS_CP) || ''; } catch (e) { return ''; }
  }
  function guardarCP(cp) {
    try { localStorage.setItem(LS_CP, cp); } catch (e) {}
  }
  function estadoDeCP(cp) {
    if (!/^\d{5}$/.test(cp)) return null;
    return CP2EDO[cp.slice(0, 2)] || null;
  }
  function esZonaLocal(cp) {
    if (!/^\d{5}$/.test(cp)) return false;
    var n = +cp;
    for (var i = 0; i < CFG.zonaLocalCP.length; i++) {
      if (n >= CFG.zonaLocalCP[i][0] && n <= CFG.zonaLocalCP[i][1]) return true;
    }
    return false;
  }

  function zonaDeCP(cp) {
    var edo = estadoDeCP(cp);
    if (!edo) return null;
    var z = CFG.estadoZona[edo] || CFG.zonaPorDefecto;
    if (!CFG.zonas[z]) return null;
    return {
      edo: edo, edoNombre: EDO_NOMBRE[edo], zona: z, cfg: CFG.zonas[z],
      local: esZonaLocal(cp)
    };
  }

  /* ======================== Producto y variante ======================== */

  var _prod = null;
  function producto() {
    if (_prod) return _prod;
    try {
      var el = document.getElementById(ID);
      if (el && el.dataset.product) { _prod = JSON.parse(el.dataset.product); return _prod; }
    } catch (e) {}
    return null;
  }

  function variantIdActual() {
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    if (inp && inp.value) return inp.value;
    var p = producto();
    return p && p.variants && p.variants[0] ? String(p.variants[0].id) : '';
  }

  function variante() {
    var p = producto(), id = variantIdActual();
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(id)) return p.variants[i];
    }
    return p.variants[0] || null;
  }

  /* ============================== Render ============================== */

  var P = 'margin:2px 0;line-height:1.4;font-size:14px;color:' + COLOR.gris + ';';
  var STRONG = 'color:' + COLOR.navy + ';';

  function bloqueAgotado(el, wa) {
    var msg = encodeURIComponent('Hola, estoy interesado en hacer una orden sobre pedido.\n' + location.href);
    el.innerHTML =
      '<p style="' + P + '">&#128230; <strong style="' + STRONG + '">Ordenalo sobre pedido a ' +
      '<a href="mailto:ventas@dibamex.com" style="color:' + COLOR.navy + ';text-decoration:underline;">ventas@dibamex.com</a></strong></p>' +
      '<p style="' + P + '">o <a href="https://wa.me/' + wa + '?text=' + msg + '" target="_blank" rel="noopener" ' +
      'style="color:' + COLOR.navy + ';font-weight:700;text-decoration:underline;">solicitalo por WhatsApp</a></p>';
    el.style.display = 'block';
  }

  function lineaCorte(t) {
    var min = minutosAlCorte(t);
    if (min === null) {
      var sale = diaDeSurtido(t);
      return '&#128230; <strong style="' + STRONG + '">Tu pedido sale el ' + fmt(sale) + '</strong>';
    }
    if (min <= 180) {                       // urgencia real solo abajo de 3 horas
      var h = Math.floor(min / 60), m = min % 60;
      var falta = h ? (h + ' h ' + (m ? m + ' min' : '')) : (m + ' min');
      return '&#128230; <strong style="' + STRONG + '">Ordena en las proximas ' + falta.trim() +
             '</strong> y sale hoy mismo';
    }
    return '&#128230; <strong style="' + STRONG + '">Ordena hoy antes de las ' + corteBonito() +
           '</strong> y sale hoy mismo';
  }

  // "normalmente" y no "llega": los rangos cumplen entre 69% y 100% segun zona.
  function lineaEnvio(icono, etiqueta, rango, sale, conCP) {
    if (!conCP) {
      var txt = rango[0] === rango[1] ? rango[0] + ' dias habiles' : rango[0] + ' a ' + rango[1] + ' dias habiles';
      return '<p style="' + P + '">' + icono + ' <strong style="' + STRONG + '">' + etiqueta + ':</strong> normalmente ' + txt + '</p>';
    }
    var a = sumaHabiles(sale, rango[0]), b = sumaHabiles(sale, rango[1]);
    var cuando = iso(a) === iso(b)
      ? 'normalmente llega el ' + fmt(a)
      : 'normalmente llega entre el ' + fmt(a) + ' y el ' + fmt(b);
    return '<p style="' + P + '">' + icono + ' <strong style="' + STRONG + '">' + etiqueta + ':</strong> ' + cuando + '</p>';
  }

  function lineaContacto(wa) {
    var msg = encodeURIComponent('Hola, quiero revisar la fecha de entrega de este producto.\n' + location.href);
    return '<p style="' + P + 'font-size:13px;">&#128241; Si se pasa la fecha, ' +
      '<a href="https://wa.me/' + wa + '?text=' + msg + '" target="_blank" rel="noopener" ' +
      'style="color:' + COLOR.navy + ';font-weight:700;text-decoration:underline;">escribenos por WhatsApp</a>' +
      ' y lo rastreamos contigo.</p>';
  }

  // Reparto propio: mismo dia de surtido, a mas tardar el siguiente habil.
  function lineaLocal(sale, t, gratis) {
    var a = sumaHabiles(sale, CFG.zonaLocalHabiles[0]);
    var b = sumaHabiles(sale, CFG.zonaLocalHabiles[1]);
    var cuando = (iso(a) === iso(t.fecha))
      ? 'hoy mismo, a mas tardar el ' + fmt(b)
      : 'el ' + fmt(a) + ', a mas tardar el ' + fmt(b);
    var et = gratis ? 'Entrega local gratis' : 'Entrega local';
    return '<p style="' + P + '">&#128667; <strong style="' + STRONG + '">' + et + ':</strong> ' + cuando +
      ' <span style="color:' + COLOR.gris + ';">con flotilla propia DIBAMEX</span></p>';
  }

  function lineaMostrador() {
    return '<p style="' + P + '">&#127970; <strong style="' + STRONG + '">Recoleccion en mostrador:</strong> ' +
      'sin costo &middot; ' + CFG.mostrador + '</p>';
  }

  function lineaCP(cp, dest) {
    var CAMBIAR = '<button type="button" data-dbx-cambiar style="background:none;border:0;padding:0 0 0 4px;' +
      'color:' + COLOR.navy + ';text-decoration:underline;cursor:pointer;font-size:13px;font-family:inherit;">cambiar</button>';
    if (cp && !dest) {
      return '<p style="' + P + '">&#128205; No reconocimos el codigo postal <strong style="' + STRONG + '">' + cp +
        '</strong>. Te mostramos el plazo nacional. ' + CAMBIAR + '</p>';
    }
    if (dest) {
      return '<p style="' + P + '">&#128205; Enviar a <strong style="' + STRONG + '">' + cp + ' &middot; ' +
        (dest.local ? CFG.zonaLocalNombre : dest.edoNombre) + '</strong> ' +
        '<button type="button" data-dbx-cambiar style="background:none;border:0;padding:0 0 0 4px;' +
        'color:' + COLOR.navy + ';text-decoration:underline;cursor:pointer;font-size:13px;font-family:inherit;">cambiar</button></p>';
    }
    return '<p style="' + P + '">&#128205; <label for="dbx-cp" style="color:' + COLOR.gris + ';">Tu codigo postal para calcular la fecha exacta:</label> ' +
      '<input id="dbx-cp" inputmode="numeric" maxlength="5" placeholder="00000" ' +
      'style="width:74px;padding:4px 8px;border:1px solid ' + COLOR.navy + ';border-radius:4px;' +
      'font-size:14px;font-family:inherit;margin-left:4px;" /></p>';
  }

  function render() {
    var el = document.getElementById(ID);
    if (!el) return;

    var wa = el.dataset.whatsapp || '5216862352697';
    var v = variante();
    if (v && v.available === false) { bloqueAgotado(el, wa); return; }

    var t = ahoraEnTZ(CFG.tz);
    var sale = diaDeSurtido(t);
    var cp = cpGuardado();
    var dest = cp ? zonaDeCP(cp) : null;
    var conCP = !!dest;

    var ter = conCP ? dest.cfg.terrestre : CFG.generico.terrestre;
    var aer = conCP ? dest.cfg.aereo : CFG.generico.aereo;

    var precio = v && typeof v.price === 'number' ? v.price / 100 : 0;
    var gratis = precio >= CFG.umbralEnvioGratisMXN;
    var etiquetaTer = gratis ? 'Envio Gratis Terrestre' : 'Envio Terrestre';

    var html = '<p style="' + P + '">' + lineaCorte(t) + '</p>';
    html += lineaCP(cp, dest);

    if (dest && dest.local) {
      html += lineaLocal(sale, t, gratis);
    } else {
      html += lineaEnvio('&#128666;', etiquetaTer, ter, sale, conCP);
      if (aer) html += lineaEnvio('&#9992;&#65039;', 'Envio Aereo (costo adicional)', aer, sale, conCP);
    }

    var mr = CFG.mostrarRecoleccion;
    if (mr === 'siempre' || (mr === 'local' && dest && dest.local)) html += lineaMostrador();
    html += lineaContacto(wa);

    el.innerHTML = html;
    el.style.display = 'block';
    el.setAttribute('aria-live', 'polite');
    enlazarCP(el);
  }

  function enlazarCP(el) {
    var input = el.querySelector('#dbx-cp');
    if (input) {
      input.addEventListener('input', function () {
        this.value = this.value.replace(/\D/g, '').slice(0, 5);
        if (this.value.length === 5) { guardarCP(this.value); render(); }
      });
    }
    var btn = el.querySelector('[data-dbx-cambiar]');
    if (btn) {
      btn.addEventListener('click', function () {
        guardarCP('');
        render();
        var i = el.querySelector('#dbx-cp');
        if (i) i.focus();
      });
    }
  }

  /* ============================== Arranque ============================== */

  function prefillDesdeCliente() {
    if (cpGuardado()) return;
    var el = document.getElementById(ID);
    var cp = el && el.dataset.customerZip ? el.dataset.customerZip.trim() : '';
    if (/^\d{5}$/.test(cp) && zonaDeCP(cp)) guardarCP(cp);
  }

  function init() {
    if (!document.getElementById(ID)) return;
    prefillDesdeCliente();
    render();

    ['theme:variant:change', 'variant:changed', 'product:variant-change', 'shopify:section:load']
      .forEach(function (n) { document.addEventListener(n, render); });

    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t && t.closest && t.closest('form[action*="/cart/add"]')) setTimeout(render, 60);
    });

    // Observer acotado al formulario, no a todo el body.
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && window.MutationObserver) {
      var deb;
      new MutationObserver(function () {
        clearTimeout(deb);
        deb = setTimeout(render, 150);
      }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
    }

    // Refresco del reloj una vez por minuto, solo si la pestana esta visible.
    setInterval(function () { if (!document.hidden) render(); }, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Se exponen para poder auditar el calculo desde la consola.
  window.DBXDelivery = { version: '3.3', render: render, cfg: CFG, zonaDeCP: zonaDeCP,
    esZonaLocal: esZonaLocal,
    _diaDeSurtido: diaDeSurtido, _esHabil: esHabil, _sumaHabiles: sumaHabiles,
    _festivos: festivos, _fmt: fmt, _ahoraEnTZ: ahoraEnTZ };
})();

/* ---------------------------------------------------------------------------
 * ORIGEN DE LOS NUMEROS
 *
 * CFG.zonas: MEDIDO. 513 envios entregados, en dias habiles (sabados, domingos,
 * festivos del articulo 74 de la LFT y jueves y viernes santo excluidos),
 * contados desde el DIA DE SURTIDO con el corte de las 12:00 que usa este
 * archivo. Del lado de la operacion: 86% de los pedidos sale el dia habil que
 * le toca y la paqueteria recoge el mismo dia en el 98%.
 *
 * CUMPLIMIENTO REAL DE CADA RANGO — por eso el texto dice "normalmente":
 *   Terrestre  Z1 Baja California  78%  (n=27)
 *              Z2 Noroeste         69%  (n=16)
 *              Z3 Resto del pais   71%  (n=184)
 *   Aereo      Z1 Baja California 100%  (n=6)
 *              Z2 Noroeste         50%  (n=16)
 *              Z3 Resto del pais   92%  (n=264)
 * Son promesas deliberadamente ajustadas: se muestra el tiempo real de la
 * mayoria en vez de un rango defensivo. De ahi la linea de contacto por
 * WhatsApp y que en ningun lado diga "garantizado".
 *
 * DOS ADVERTENCIAS MEDIDAS, decididas asi a proposito:
 *   - Al Noroeste el avion NO gana dias: mediana 4, hasta 5. A Sonora y Sinaloa
 *     el aereo tarda mas que al centro del pais. Ese renglon falla la mitad de
 *     las veces. Se muestra igual, por decision comercial.
 *   - En Baja California el aereo queda igual que el terrestre (2 a 3) y ademas
 *     cuesta extra. Tambien se muestra por decision comercial.
 *
 * CFG.zonaLocalCP: 21000-21399 = ciudad de Mexicali. Los CP locales observados
 * en pedidos reales van de 21030 a 21395, todos urbanos; el catalogo de
 * localidades del valle arranca arriba del 21400. NO hay medicion de paqueteria
 * para Mexicali (2 guias): su plazo sale de la operacion de reparto propio, no
 * de estos datos.
 *
 * CFG.cerrarSemanaSanta: confirmado. La medicion del CRM excluye jueves y
 * viernes santo.
 *
 * COBERTURA DE CP2EDO: prefijos 01-16 y 20-99. Los prefijos 17, 18 y 19 no
 * aparecen porque el catalogo no los asigna a ningun estado. Cualquier CP que
 * no resuelva estado cae al plazo nacional generico, con aviso al cliente, y
 * cualquier estado fuera de CFG.estadoZona cae a CFG.zonaPorDefecto.
 *
 * RECALIBRACION: el CRM recalcula estos numeros cada 90 dias. Si el
 * cumplimiento de una zona baja, se sube el techo de esa zona. No se redibuja
 * el mapa de zonas.
 * ------------------------------------------------------------------------- */
